import React from "react";

// For passing values related to paging in question management.
// There is need to pass page indexes and the number of items per page to match deleting or creating questions, adjusting the number of questions displayed on the page, etc.
export const QuestionPaginationContext = React.createContext(undefined);
